import script from "./AllInOneBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./AllInOneBanner.vue?vue&type=script&setup=true&lang=js"

import "./AllInOneBanner.vue?vue&type=style&index=0&id=35fbd85e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35fbd85e"]])

export default __exports__